import styled from '@emotion/styled';
// import { themeGet } from '@styled-system/theme-get';

const getIconBackground = ({ theme: { color }, color: iconColor }) => {
  switch (iconColor) {
    case 'purple':
      return color.colorPurple20;
    case 'orange':
      return color.colorOrange10;
    case 'pink':
      return color.colorPink10;
    case 'teal':
      return color.colorTeal10;
    case 'green':
      return color.colorGreen10;
    case 'turquoise':
      return color.colorTurquoise10;
    case 'yellow':
      return color.colorYellow10;
    case 'violet':
      return color.colorViolet10;
    default:
      return color.colorGrayBlue10;
  }
};

const getIconColor = ({ theme: { color }, color: iconColor }) => {
  switch (iconColor) {
    case 'purple':
      return color.colorPurple50;
    case 'orange':
      return color.colorOrange60;
    case 'pink':
      return color.colorPink60;
    case 'teal':
      return color.colorTeal60;
    case 'green':
      return color.colorGreen50;
    case 'blue':
      return color.colorBlue50;
    case 'turquoise':
      return color.colorTurquoise60;
    case 'yellow':
      return color.colorYellow70;
    case 'violet':
      return color.colorViolet50;
    default:
      return color.colorGrayBlue90;
  }
};

export const StyledIcon = styled.figure`
  padding-bottom: 100%;
  position: relative;
  border-radius: 50%;
  background: ${getIconBackground};

  path {
    stroke: transparent;
    fill: ${getIconColor};
  }

  svg {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 50%;
    transform: translate(-50%, -50%);
  }
`;

export default StyledIcon;
